import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter, HostListener, Input,
    Output,
    Renderer2,
    ViewChild
} from '@angular/core';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { Utils } from 'sharedGuiSmall/utils/utils';
import { ComboComponent } from './combo.component';
import { ItemData } from './item-data';

@Component({
    selector: 'boundlist',
    templateUrl: './boundlist.component.html',
    styleUrls: ['./boundlist.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoundListComponent {

    customDatesText = $localize`CUSTOM_DATES`;

    @Input()
    width: number = 200;

    @Input()
    testId: string = "";

    @ViewChild('main')
    private main!: ElementRef<HTMLDivElement>;

    combo: ComboComponent | undefined;

    BoundListData: Array<ItemData> = [];

    backgroundColor: string = 'white';

    @Input()
    maxHeight: number = 350;

    @Input()
    private minHeight: number = 50;

    @Input()
    isNewCompany: boolean = false;

    @Input()
    public currencyCombo: boolean = false;

    @Input() 
    isUpperMenuCombo: boolean = false;

    @Output() afterviewinit: EventEmitter<any> = new EventEmitter();
    getAfterViewInit(): EventEmitter<any> {
        return this.afterviewinit;
    }

    zIndex: number = 0;

    private isTextCentered: boolean = false;

    public showCustomDatesBtn: boolean = false; // Use datepicker

    public customDatesClick: Function | undefined;

    private leftPosition: number = 0;
    private topPosition: number = 0;
    private initialWindowWidth: number = -1;
    private interval: number = 5;

    constructor(private element: ElementRef, private renderer: Renderer2, private chDet: ChangeDetectorRef) { }

    ngAfterViewInit(): void {

        if (this.showCustomDatesBtn && this.width < 115)
            this.width = 115;

        if (this.combo && this.combo.useFullWidth)
            this.width = this.combo.inputAreaElement?.nativeElement?.offsetWidth;

        this.renderer.setStyle(this.element.nativeElement, "width", this.width + 'px');
        this.renderer.setStyle(this.main.nativeElement, "width", this.width + 'px');
        //this.renderer.setAttribute(this.element.nativeElement, "tabindex", "-1");

        if (this.combo)
            this.zIndex = Utils.getZIndex(this.combo.getElement());

        console.log('set boundlist z ', this.zIndex);

        this.renderer.setStyle(this.element.nativeElement, "z-index", this.zIndex);
        this.afterviewinit.emit();
    }

    getElement() {
        return this.element.nativeElement as HTMLElement;
    }

    getMainEl(): any {
        return this.main.nativeElement;
    }

    setWidth(width: number): void {
        this.width = width;
    }

    setCombo(combo: ComboComponent): void {
        this.combo = combo;
        combo.setBoundList(this);
        this.width = combo.width;
        if (combo && combo.inputElement)
            this.backgroundColor = getComputedStyle(combo.inputElement.nativeElement).getPropertyValue("background-color");
        this.chDet.detectChanges();
    }

    setTextCentered(isCentered: boolean) {
        this.isTextCentered = isCentered;
    }

    show(zIndex = this.zIndex): void {
        if (!this.combo)
            throw new Error('Critical Error: Boundlist is not connected to a combo');

        const comboEl = this.combo.getElement();
        const comboRect = comboEl.getBoundingClientRect();

        this.renderer.setStyle(this.element.nativeElement, "z-index", Utils.getZIndex(comboEl));

        this.leftPosition = this.combo.useFullWidth ? comboRect.left : comboRect.left - (this.width - this.combo.width) / 2;
        this.renderer.setStyle(this.element.nativeElement, 'left', this.leftPosition + 'px');

        const listHeight = DomSmallUtils.outerHeight(this.getElement());
        //down direction
        let topPosition = comboRect.bottom;

        const positionAfterShow = topPosition + listHeight;

        let isInViewportAfterShow =
            //comboRect.top >= 0 &&
            //&& comboRect.left >= 0
             positionAfterShow <= (window.innerHeight || document.documentElement.clientHeight)
           //&& comboRect.right <= (window.innerWidth || document.documentElement.clientWidth);

        if (!isInViewportAfterShow) {
            //change to top direction
            topPosition = comboRect.top - listHeight;
        }

        if (!isInViewportAfterShow) {
            isInViewportAfterShow =
                topPosition >= 0 &&
                topPosition <= (window.innerHeight || document.documentElement.clientHeight);

            if (!isInViewportAfterShow) {
                const overFlowFromOpenBottom = positionAfterShow - window.innerHeight;
                const overFlowFromOpenTop = topPosition > 0 ? topPosition - window.innerHeight : Math.abs(topPosition);

                const screenEdgeOffset = 10;

                if (overFlowFromOpenBottom < overFlowFromOpenTop) {
                    topPosition = comboRect.bottom;
                    this.maxHeight = listHeight - overFlowFromOpenBottom - screenEdgeOffset;
                }
                else {
                    topPosition = topPosition > 0 ? topPosition - overFlowFromOpenTop - screenEdgeOffset : topPosition + overFlowFromOpenTop + screenEdgeOffset;
                    this.maxHeight = listHeight - overFlowFromOpenTop - screenEdgeOffset;
                }

                this.chDet.detectChanges();
            }
        }

        if (window.scrollY > 0)
            topPosition += window.scrollY;

        this.setTopPosition(topPosition);

        this.renderer.setStyle(this.element.nativeElement, 'display', 'block');

        if (this.combo.useFullWidth) {
            this.renderer.setStyle(this.element.nativeElement, 'width', this.combo.inputAreaElement?.nativeElement?.offsetWidth + 'px');
            this.renderer.setStyle(this.main.nativeElement, 'width', this.combo.inputAreaElement?.nativeElement?.offsetWidth + 'px');
        }

        this.initialWindowWidth = document.body.clientWidth;
        this.setZIndex(zIndex);
        this.combo.setInitialScrolls();
    }

    setData(data: Array<ItemData>): void{
        this.BoundListData = data;
        this.chDet.detectChanges();
    }

    setTestId(value: string): void {
        this.testId = value;
    }

    setMaxHeight(value: number): void {
        this.maxHeight = value;
    }

    setZIndex(index: number): void {
        this.renderer.setStyle(this.element.nativeElement, "z-index", index);
    }

    onSelectItem(item: ItemData) {

        if (!this.combo)
            throw new Error('Critical Error: Boundlist is not connected to a combo');

        this.combo.selectitem.emit(item);

        if (!item.disabled) {
            let val = item.id;
            this.combo.setValue(val);
            this.combo.hideBoundList();
            if (this.combo.inputElement)
                this.combo.inputElement.nativeElement.focus();
        }
    }

    onBlur(event: Event): void {
        if (!this.combo)
            throw new Error('Critical Error: Boundlist is not connected to a combo');
        this.combo.hideBoundList();
    }

    handleCustomDatesClick(): void {
        if (!this.combo)
            throw new Error('Critical Error: Boundlist is not connected to a combo');
        this.combo.hideBoundList();

        if (this.customDatesClick)
            this.customDatesClick();
    }

    getInitLeftPosition(): number {
        return this.leftPosition;
    }

    getInitTopPosition(): number {
        return this.topPosition;
    }

    setTopPosition(position: number): void {
        if (!this.combo) return;

        this.topPosition = position;
        if (this.currencyCombo) {
            this.topPosition += this.interval;
        }
        this.renderer.setStyle(this.element.nativeElement, 'top', this.topPosition + 'px');
    }

    addNewCompanyBtn(): void {
        this.isNewCompany = true;
    }

    addNewCompany(): void {
        if (this.combo)
            this.combo.newCompanyClick.emit();
    }

    setBoundlistStyle(style: string[]): void {
        this.renderer.setStyle(this.element.nativeElement, style[0], style[1]);
    }

    getValue(text: string): string {
        return text.split('10%')[0]?.trim();
    }

    getDiscount(text: string): string {
        return text.split('plans ')[1]?.trim();
    }

    @HostListener('window:resize', ['$event'])
    handleResize(): void {
        const currentWindowWidth: number = document.body.clientWidth;
        if (this.initialWindowWidth == currentWindowWidth)
            return;
        if (!this.combo)
            throw new Error('Critical Error: Boundlist is not connected to a combo');
        this.initialWindowWidth = currentWindowWidth;
        this.combo.hideBoundList();
    }
}
